import i18n from '../../../../../../i18n'
import { WikiIndexEntry } from '../../../../../../api/help/model'
import { WikiIndexEntryVM } from '../../sidePanel.model'
import { wikiIndexItemMapperToVM } from '../../sidePanel.mapper'

const extractNumber = path => {
  const segments = path.split('/')
  if (segments.length >= 4) {
    const numberPart = segments[3].split('-')[0]
    const parsedNumber = parseInt(numberPart, 10)
    return isNaN(parsedNumber) ? Infinity : parsedNumber
  }
  return Infinity
}

export const helpIndexItemsMapperToVM = (
  indexRoot: WikiIndexEntry,
  section: string
): WikiIndexEntryVM[] => {
  if (!indexRoot || !indexRoot.subPages) return []

  const localeInPath = `/${section.split('/')[1]}`

  const indexForCurrentLocale = indexRoot.subPages.find(subpage => subpage.path === localeInPath)

  let indexForCurrentSection = indexForCurrentLocale?.subPages.find(
    subpage => subpage.path === section
  )?.subPages

  // Default help index (if the wiki hasn't context help for the current page)
  if (!indexForCurrentSection) {
    const defaultHelpPagePath = i18n.t('help:sideHelpRoutes.default')
    indexForCurrentSection = indexForCurrentLocale?.subPages.find(
      subpage => subpage.path === defaultHelpPagePath
    )?.subPages
  }

  return indexForCurrentSection
    ? indexForCurrentSection.map(wikiIndexItemMapperToVM).sort((a, b) => {
        const numA = extractNumber(a.path)
        const numB = extractNumber(b.path)
        return numA - numB
      })
    : []
}
